import { useParams } from "react-router-dom"
import { useGetMoneyFlow } from "../api/case/document"
import { useGetSankeyData } from "../api/sankeyData/get"
import { useCurrentStep } from "./useCurrentStep"

export const useMoneyflowLoading = () => {
    const { documentId } = useParams()

    const { data: moneyflow, isFetching: isMoneyflowFetching } = useGetMoneyFlow(documentId)
    const { currentStep } = useCurrentStep()
    const { isFetching: isSankeyFetching } = useGetSankeyData(moneyflow?.sankeyData[currentStep], !documentId)

    return isMoneyflowFetching || isSankeyFetching
}

